import React, { Component } from 'react';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonAlert,
  IonSpinner,
  IonBadge,
  IonText,
} from '@ionic/react';

import PublicLinks, { formatDateTime } from '../services/publicLinks';
import { errorMessage } from '../utils/errorMessage';

const STATES = {
  pending: { color: 'warning', label: 'In attesa della tua risposta' },
  confirmed: { color: 'success', label: 'Appuntamento confermato' },
  refused: { color: 'medium', label: 'Proposta rifiutata' },
  expired: { color: 'medium', label: 'Proposta scaduta' },
  cancelled: { color: 'medium', label: 'Appuntamento annullato' },
};

export default class VaccineResponsePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: this.props.match.params.token,
      appointment: null,
      loading: true,
      notFound: false,
      busy: false,
      alert: null,
      error: null,
    };
  }

  async componentDidMount() {
    try {
      const response = await PublicLinks.vaccine(this.state.token);
      this.setState({ appointment: response.data.data, loading: false });
    } catch (error) {
      this.setState({ loading: false, notFound: error?.response?.status === 404, error: errorMessage(error) });
    }
  }

  async respond(response) {
    this.setState({ busy: true, error: null });
    try {
      const result = await PublicLinks.respondVaccine(this.state.token, response);
      this.setState({ appointment: result.data.data, busy: false });
    } catch (error) {
      this.setState({ busy: false, error: errorMessage(error) });
    }
  }

  renderBody() {
    const { appointment: a, loading, notFound, busy, error } = this.state;

    if (loading) return <IonSpinner />;
    if (notFound) return <p>Link non valido o appuntamento non più disponibile.</p>;
    if (!a) return <p>{error}</p>;

    const state = STATES[a.state] || STATES.expired;

    return (
      <IonCard>
        <IonCardHeader>
          <IonCardTitle>{a.vaccines}</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <p>{formatDateTime(a.scheduled_at)}</p>
          <p>{a.shop?.name}</p>
          <p style={{ margin: '12px 0' }}>
            <IonBadge color={state.color}>{state.label}</IonBadge>
          </p>

          {a.state === 'pending' && a.response_deadline && (
            <p>Rispondi entro il {formatDateTime(a.response_deadline)}: dopo la dose sarà riassegnata.</p>
          )}

          {error && (
            <IonText color="danger">
              <p>{error}</p>
            </IonText>
          )}

          {a.state === 'pending' && (
            <>
              <IonButton expand="block" color="success" disabled={busy} onClick={() => this.respond('confirmed')}>
                Conferma appuntamento
              </IonButton>
              <IonButton
                expand="block"
                color="medium"
                fill="outline"
                disabled={busy}
                onClick={() => this.setState({ alert: 'refused' })}
              >
                Rifiuta
              </IonButton>
            </>
          )}

          {a.can_cancel && (
            <>
              <p>Puoi annullare fino al {formatDateTime(a.cancel_deadline)}.</p>
              <IonButton
                expand="block"
                color="danger"
                fill="outline"
                disabled={busy}
                onClick={() => this.setState({ alert: 'cancel' })}
              >
                Annulla appuntamento
              </IonButton>
            </>
          )}

          {a.state === 'confirmed' && !a.can_cancel && a.shop?.call_number && (
            <p>
              Per modifiche contatta la farmacia: <a href={`tel:${a.shop.call_number}`}>{a.shop.call_number}</a>
            </p>
          )}
        </IonCardContent>
      </IonCard>
    );
  }

  render() {
    const { alert } = this.state;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Appuntamento vaccino</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          {this.renderBody()}

          <IonAlert
            isOpen={!!alert}
            onDidDismiss={() => this.setState({ alert: null })}
            header={alert === 'cancel' ? "Annullare l'appuntamento?" : 'Rifiutare la proposta?'}
            message={alert === 'cancel' ? 'La dose tornerà disponibile per altri pazienti.' : "Tornerai in lista d'attesa."}
            buttons={[
              { text: 'No', role: 'cancel' },
              { text: 'Sì', handler: () => this.respond(alert) },
            ]}
          />
        </IonContent>
      </>
    );
  }
}
